import { take, all, takeLatest, call } from 'redux-saga/effects';
import { requestPuppy, isApiError } from '@wix/da-http-client';
import { addMediaToTier, reduxModuleLoaded } from './actions';
import { putErrorNotification } from '../../../utils/saga';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'server_error',
                errorDescription: 'Could not create asset',
                status: 'error'
            };
        }
        return {
            success: true
        };
    }
}
function* handleAddMediaToTier(action) {
    const data = {
        tier_deviationid: action.payload.tierDeviation.deviationId,
        deviationids: action.payload.deviations.map((d)=>d.deviationId)
    };
    const response = yield call(requestPuppy, {
        url: '/tier/deviation/add',
        method: 'post',
        data
    }, fakeResponse);
    if (!response) {
        yield putErrorNotification('There was an error adding to the tier, please try again.');
        return;
    }
    if (isApiError(response)) {
        yield putErrorNotification(`Error: ${response.errorDescription}}`);
        return;
    }
    window.location.reload();
}
export default function* dasSaga() {
    yield take(reduxModuleLoaded); // wait for redux to load
    yield all([
        takeLatest(addMediaToTier, handleAddMediaToTier)
    ]);
}

//# sourceMappingURL=tierManageContentSaga.js.map